module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Profile_04-53b6c8fc2cbf47c8501aa1938deec909.jpg";